export default __webpack_public_path__ + "static/media/close-icon.deaa1883.svg";